import { SelectOptionTree } from "../types";

/**
 * Сортировка категорий по количеству товаров (rollup по поддереву) —
 * по убыванию, с алфавитным порядком как tiebreaker. Категории без счётчика
 * уходят в конец.
 */
export const compareByProductCount = (
  a: SelectOptionTree,
  b: SelectOptionTree,
): number => {
  const countA = a.productCount ?? -1;
  const countB = b.productCount ?? -1;

  if (countB !== countA) return countB - countA;

  return (a.label ?? "").localeCompare(b.label ?? "");
};
